<script>
	import Snackbar, { Actions, Label as SnackbarLabel } from "@smui/snackbar";
	import IconButton from "@smui/icon-button";
	import Fab, { Label as FabLabel, Icon as FabIcon } from "@smui/fab";

	export let modified;
	export let text = "Save changes";
	export let textDisabled = "Nothing to save";
	export let snackbarText = "Changes saved.";
	export let color = "primary";

	let snackbar;

	$: changesToSave = Object.values(modified).some((v) => v !== null && v !== undefined && v !== false);
</script>

<div class="save-container" class:disabled={!changesToSave}>
	<Fab on:click on:click={() => snackbar.open()} {color} extended>
		{#if changesToSave}
			<FabIcon class="material-icons">save</FabIcon>
		{/if}
		<FabLabel>
			{changesToSave ? text : textDisabled}
		</FabLabel>
	</Fab>
</div>

<Snackbar bind:this={snackbar}>
	<SnackbarLabel>{snackbarText}</SnackbarLabel>
	<Actions>
		<IconButton class="material-icons" title="Dismiss">close</IconButton>
	</Actions>
</Snackbar>

<style lang="scss">
	.save-container {
		position: sticky;
		bottom: 50px;
		z-index: 10;
		display: flex;
		justify-content: flex-end;
		pointer-events: none;

		:global(button) {
			transition: background-color 0.3s ease;
			pointer-events: all;
		}

		&:global(.disabled) {
			:global(button) {
				pointer-events: none;
				background-color: $disabled;
			}
		}
	}
</style>
